'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Card, CardContent } from '@achra/ui/card';
import { LogIn } from 'lucide-react';
interface ConnectAccountStepProps {
  onLogin: () => void;
}
function ConnectAccountStep(t0) {
  const $ = _c(4);
  const {
    onLogin
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-primary/10 text-primary flex size-12 items-center justify-center rounded-full"><LogIn className="size-5" aria-hidden="true" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-2"><h1 className="text-2xl font-semibold tracking-tight">Connect your account</h1><p className="text-muted-foreground max-w-md text-sm">Sign in with your wallet to start setting up your Achra workspace.</p></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onLogin) {
    t3 = <Card className="overflow-hidden"><CardContent className="flex flex-col items-center gap-5 px-8 py-12 text-center">{t1}{t2}<Button onClick={onLogin} className="min-w-44">Log in</Button></CardContent></Card>;
    $[2] = onLogin;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export { ConnectAccountStep };